import { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { closeModal } from '../../services/modal';
import { getTheme, Theme } from '../theme';
import { stores, useStore } from '../../utils/store';
import ModalBody from './ModalBody';
import { colorOpacity } from '../../utils/style';

let scroll = 0;
let opened = false;

export default function ModalController() {
    const [theme,] = useState<Theme>(getTheme);
    let [modal,] = useStore(stores.UI.modal);

    if (modal && !opened) {
        const root = document.getElementById('root') as any;
        opened = true;

        scroll = window.scrollY;
        root.style.transform = `translateY(-${window.scrollY}px)`
        root.classList.add('modal-open');
        window.scrollTo(0, 0);
    }

    if (!modal && opened) {
        const root = document.getElementById('root') as any;
        opened = false;

        root.classList.remove('modal-open')
        root.style.transform = '';
        window.scrollTo(0, scroll)
    }

    if (!modal) return null;

    return (
        <ThemeProvider theme={theme}>
            <Wrapper onMouseDown={() => closeModal()}>
                <div onMouseDown={(e) => e.stopPropagation()}>
                    {modal ? <ModalBody {...modal} /> : ''}
                </div>

            </Wrapper>
        </ThemeProvider>
    )
}

const Wrapper = styled.div`
    color: ${props => props.theme.font.default.color};
    font-weight: ${props => props.theme.font.default.weight};
    font-size: ${props => props.theme.font.default.size};
    padding: 30px 20px;

    background-color: #00000044;
    background-color: ${props => colorOpacity(props.theme.backgroundColor, 0.5)};
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`